import './App.css';
import React from "react";
import { HashRouter } from "react-router-dom"; // Change this
import PostLoginRedirect from './pages/PostLoginRedirect';

export default function App() {
  return (
    <HashRouter>
      <PostLoginRedirect />
    </HashRouter>
  );
}